import React, { useState } from 'react';
import BestellingBevestigen from '../Components/BestellingBevestigen';
import { Helmet } from 'react-helmet'

const ProductenBestelling = () => {

  const producten = [
    { id: 1, naam: 'Côte à l\'os' },
    { id: 2, naam: 'Entrecote' },
    { id: 3, naam: 'Rib eye De Spycker' },
    { id: 4, naam: 'Filet Pur' },
    { id: 5, naam: 'Filet mignon' },
    { id: 6, naam: 'Chateaubriand' },
    { id: 7, naam: 'Biefstuk 1ste Keus' },
    { id: 8, naam: 'Schorsvel/kraaibiefstuk' },
    { id: 9, naam: 'Biefstuk De Spycker' },
    { id: 10, naam: 'Tournedos' },
    { id: 11, naam: 'Zenuwbiefstuk' },
    { id: 12, naam: 'Gemarineerde biefstuk' },
    { id: 13, naam: 'Rosbief' },
    { id: 14, naam: 'Americain' },
    { id: 15, naam: 'Stoofvlees' },
    { id: 16, naam: 'Schenkel' },
    { id: 17, naam: 'Soepvlees zonder been' },
    { id: 18, naam: 'Rundstong' },
    { id: 19, naam: 'Rundscarpaccio' },
    { id: 20, naam: 'Rundshart' },
    { id: 21, naam: 'Rundslever' },
    { id: 22, naam: 'Kalfsfricassee' },
    // { id: 23, naam: 'Kalfsnier' },
    { id: 24, naam: 'Kalfsgehakt' },
    { id: 25, naam: 'Kalfsgebraad' },
    { id: 26, naam: 'Kalfskotelet' },
    { id: 27, naam: 'Kalfslapje' },
    { id: 28, naam: 'Kalfsmedaillon' },
    { id: 29, naam: 'Kalfsschenkel' },
    { id: 30, naam: 'Kalfsworst' },
    { id: 31, naam: 'Kalfstong' },
    { id: 32, naam: 'Kalfslende' },
    { id: 33, naam: 'Kalfsfilet pur' },
    { id: 34, naam: 'Kalfslever' },
    { id: 35, naam: 'Gepaneerd kalfslapje' },
    { id: 36, naam: 'Kalfswok' },
    { id: 37, naam: 'cote a los kalf' },
    { id: 38, naam: 'Filetkotelet' },
    { id: 39, naam: 'Ribkotelet' },
    { id: 40, naam: 'Spieringkotelet' },
    { id: 41, naam: 'Mignonette' },
    { id: 42, naam: 'Hespgebraad' },
    { id: 43, naam: 'Filetgebraad' },
    { id: 44, naam: 'Spieringgebraad' },
    { id: 45, naam: 'Varkenshaasje' },
    { id: 46, naam: 'Varkenstoofvlees' },
    { id: 47, naam: 'Vleesribben' },
    { id: 48, naam: 'Vers spek' },
    { id: 49, naam: 'Varkenswangen' },
    { id: 50, naam: 'BBQ Rib' },
    // { id: 51, naam: 'Hammetje' },
    { id: 52, naam: 'Varkenstong' },
    { id: 53, naam: 'Gemarineerd spek' },
    { id: 54, naam: 'Varkenshersenen' },
    { id: 55, naam: 'Orloff' },
    { id: 56, naam: 'Varkenspoot' },
    { id: 57, naam: 'Hoevekip' },
    { id: 58, naam: 'Kipfilet' },
    { id: 59, naam: 'Kippenbout natuur' },
    { id: 60, naam: 'Kipfilet gemarineerd' },
    { id: 61, naam: 'Kippenbout gemarineerd' },
    { id: 62, naam: 'Apero kip' },
    { id: 63, naam: 'Kalkoenfiletgebraad' },
    { id: 64, naam: 'Lamskroon' },
    { id: 65, naam: 'Konijn' },
    { id: 66, naam: 'Kippenbil' },
    { id: 67, naam: 'Kalkoenhaasje gemarineerd' },
    { id: 68, naam: 'Preparé' },
    { id: 69, naam: 'Preparé tartaar' },
    { id: 70, naam: 'Bereid gehakt' },
    { id: 71, naam: 'Vleessalade' },
    { id: 72, naam: 'Hoevesalade' },
    { id: 73, naam: 'Kippesalade' },
    { id: 74, naam: 'Geroosterde beenhamsalade' },
    { id: 75, naam: 'Krabsalade' },
    // { id: 76, naam: 'Pastasalade' },
    { id: 77, naam: 'Bloedworst' },
    { id: 78, naam: 'Witte pens' },
    { id: 79, naam: 'Hoofdvlees' },
    { id: 80, naam: 'Soepvlees in vinaigrette' },
    { id: 81, naam: 'Hoevebroodje' },
    { id: 82, naam: 'Grillworst' },
    { id: 83, naam: 'Boerenpaté' },
    { id: 84, naam: 'Boerenham 4 maand' },
    { id: 85, naam: 'Beenham' },
    { id: 86, naam: 'Salami' },
    { id: 87, naam: 'Spek gezouten' },
    { id: 88, naam: 'Spek gerookt' },
    { id: 89, naam: 'Boerenring' },
    { id: 90, naam: 'Hespeworst' },
    // { id: 92, naam: 'Spekworst' },
    { id: 93, naam: 'Hoevespek' },
    { id: 94, naam: 'Droge worst' },
    { id: 95, naam: 'Droge worst fijn' },
    { id: 96, naam: "Pur Porc De Spycker 'Stantje'" },
    { id: 97, naam: 'Pain de Provence' },
    { id: 98, naam: 'Polderlander 9 maand' },
    { id: 100, naam: 'Superano 15 maand' },
    { id: 101, naam: 'Gebakken kalkoenham' },
    { id: 102, naam: 'Huisgemaakt mosterdspek' },
    { id: 103, naam: 'Gehakt' },
    { id: 104, naam: 'Braadworst' },
    { id: 105, naam: 'Chipolata' },
    { id: 106, naam: 'Kaasburger' },
    { id: 107, naam: 'Kippenburger' },
    { id: 108, naam: 'Cordon Bleu' },
    { id: 109, naam: 'Schnitzel varken' },
    { id: 110, naam: 'Schnitzel kip' },
    { id: 111, naam: 'Gehaktbroodje' },
    { id: 112, naam: 'Hamburger' },
    { id: 113, naam: 'Blinde vinken' },
    { id: 114, naam: 'Rundsbrochette' },
    { id: 115, naam: 'Rundswok' },
    // { id: 116, naam: 'Varkensbrochette' },
    // { id: 117, naam: 'Varkensgyros' },
    { id: 118, naam: 'Kippenbrochette' },
    { id: 119, naam: 'Kippengyros' },
    { id: 120, naam: 'BBQ-worst' },
    { id: 121, naam: 'Balletjes in tomatensaus' },
    // { id: 122, naam: 'Spaghettisaus' },
    { id: 123, naam: 'Beef burger' },
    // { id: 124, naam: 'Pittavlees' },
    // { id: 125, naam: 'Hoeveburger' },
    // { id: 126, naam: 'Beemsterburger' },
    { id: 127, naam: 'Brochette kalf' },
    { id: 128, naam: 'Grillstick' },
    // { id: 129, naam: 'Bereid kalfsblanquette' },
    { id: 130, naam: 'Short rib' },
    { id: 131, naam: 'Colli varken' },
    { id: 132, naam: 'Colli gemengd' },
    { id: 133, naam: 'Colli rund' },
    { id: 134, naam: 'Fondue varié' },
    { id: 135, naam: 'Fondue de luxe' },
    { id: 136, naam: 'Gourmet/steengrill' },
    { id: 137, naam: "Côte à l'os kalf" },
    { id: 138, naam: "Varkensoor" },
    { id: 139, naam: "Varkensnier" },
    { id: 140, naam: "Flandrien jong" },
    { id: 141, naam: "Emmental" },
    { id: 142, naam: "Beemster belegen" },
    { id: 143, naam: "Kadett" },
    { id: 144, naam: "Côte à l'os varken" },
    { id: 145, naam: "BBQ Beenham" }
  ];

  const categorieen = {
    "Rund": [
      "Côte à l'os", "Entrecote", "Rib eye De Spycker", "Filet Pur", "Filet mignon",
      "Chateaubriand", "Biefstuk 1ste Keus", "Schorsvel/kraaibiefstuk", "Biefstuk De Spycker",
      "Tournedos", "Zenuwbiefstuk", "Gemarineerde biefstuk", "Rosbief", "Americain",
      "Stoofvlees", "Schenkel", "Soepvlees zonder been", "Rundstong", "Rundscarpaccio",
      "Rundshart", "Rundslever", "Kalfsfricassee", "Kalfskotelet",
      "Kalfslapje", "Kalfsmedaillon", "Kalfsschenkel", "Kalfsworst", "Kalfstong",
      "Kalfslende", "Kalfsfilet pur", "Kalfslever", "Gepaneerd kalfslapje",
      "Côte à l'os kalf", "Kalfsgebraad"
    ],
    "Varken": [
      "Filetkotelet", "Ribkotelet", "Spieringkotelet", "Mignonette", "Hespgebraad",
      "Filetgebraad", "Spieringgebraad", "Varkenshaasje", "Varkenstoofvlees", "Vleesribben",
      "Vers spek", "Varkenswangen", "Varkenstong",
      "Varkenshersenen", "Orloff", "Varkenspoot", "Varkensoor", "Varkensnier"
    ],
    "Gevogelte": [
      "Hoevekip", "Kipfilet", "Kippenbout natuur",
      "Kippenbil", "Kalkoenfiletgebraad", "Kalkoenhaasje gemarineerd", "Konijn"
    ],
    "Charcuterie": [
       "Vleessalade", "Hoevesalade", "Kippesalade", "Geroosterde beenhamsalade", "Krabsalade",  "Grillworst", "Hespeworst", "Droge worst", "Droge worst fijn", 
      "Hoevespek", "Spek gezouten", "Spek gerookt",  "Boerenpaté", "Pur Porc De Spycker 'Stantje'", "Pain de Provence", 
      "Hoofdvlees", "Soepvlees in vinaigrette", "Hoevebroodje", "Boerenham 4 maand", "Beenham", 
      "Gebakken kalkoenham", "Salami", "Boerenring", "Superano 15 maand", "Preparé", "Preparé tartaar", "Bereid gehakt", "Bloedworst", "Witte pens", 
      "Polderlander 9 maand", "Huisgemaakt mosterdspek"
    ],
    "Panklaar": [
      "Kaasburger", "Kippenburger", "Beef burger", "Hoeveburger", "Beemsterburger", "Braadworst", "Chipolata", "Cordon Bleu", "Schnitzel varken", "Schnitzel kip", 
      "Rundsbrochette", "Varkensbrochette", "Kippenbrochette", "Varkensgyros", "Kippengyros", 
      "Brochette kalf", "Gehakt", "Kalfsgehakt", "Gehaktbroodje", "Balletjes in tomatensaus", "Pittavlees", "Rundswok", 
      "Bereid kalfsblanquette", "Hamburger", "Blinde vinken", "Kalfswok", 
    ],
    "BBQ": [
       "BBQ Rib", "Gemarineerd spek", "Côte à l'os varken", "Kipfilet gemarineerd", "Kippenbout gemarineerd",  "Apero kip", "Spekworst", "BBQ-worst", "Short rib", "Grillstick", "BBQ Beenham"
    ],
    "Allerlei": [
       "Flandrien jong", "Emmental", "Lamskroon", "Beemster belegen", "Kadett",  "Colli varken", "Colli gemengd", "Colli rund",  "Fondue varié", "Fondue de luxe", "Gourmet/steengrill"
    ]
  };

  const alleenStuk = ['Konijn', 'Varkensnier', 'Varkensoor', 'Varkenspoot', 'Kalfstong', "Rundstong", "Droge worst", "Grillworst", "Droge worst fijn", "Hoevebroodje", "Bloedworst", "Witte pens", "Pur Porc De Spycker 'Stantje'", "BBQ Rib", "Gemarineerd spek", "Côte à l'os varken", "Apero kip", "Spekworst", "BBQ-worst", "Colli varken", "Colli rund", "Colli gemengd", "Fondue varié", "Fondue de luxe", "Gourmet/steengrill", "BBQ Beenham"]

  const perPieceProducten = ['Rundstong', 'Kalfstong', 'Varkenspoot', 'Varkensoor', 'Droge worst', 'Droge worst fijn', "Côte à l'os", "Entrecote", "Rib eye De Spycker", "Filet Pur", "Filet mignon",
      "Chateaubriand", "Biefstuk 1ste Keus", "Schorsvel/kraaibiefstuk", "Biefstuk De Spycker",
      "Tournedos", "Zenuwbiefstuk", "Gemarineerde biefstuk", "Schenkel", "Rundstong", "Rundscarpaccio",
      "Rundshart", "Rundslever", "Kalfskotelet",
      "Kalfslapje", "Kalfsmedaillon", "Kalfsschenkel", "Kalfsworst",
      "Kalfslende", "Kalfsfilet pur", "Kalfslever", "Gepaneerd kalfslapje",
      "Côte à l'os kalf", "Filetkotelet", "Ribkotelet", "Spieringkotelet", "Mignonette",
      "Filetgebraad","Varkenshaasje", "Vleesribben",
      "Vers spek", "Varkenswangen", "Varkenstong", "Orloff", "Varkensnier", "Hoevekip", "Kipfilet", "Kippenbout natuur",
      "Kippenbil", "Kalkoenhaasje gemarineerd", "Konijn", "Kaasburger", "Kippenburger", "Beef burger", "Hoeveburger", "Beemsterburger", "Braadworst", "Chipolata", "Cordon Bleu", "Schnitzel varken", "Schnitzel kip", 
      "Rundsbrochette", "Varkensbrochette", "Kippenbrochette", "Varkensgyros",
      "Brochette kalf", "Gehaktbroodje", "Balletjes in tomatensaus", "Pittavlees", "Short rib", "Grillstick", 
      "Bereid kalfsblanquette", "Hamburger", "Blinde vinken", "BBQ Rib", "Gemarineerd spek", "Côte à l'os varken", 
      "Kipfilet gemarineerd", "Kippenbout gemarineerd",  "Apero kip", "Spekworst", "BBQ-worst", "Lamskroon", "Colli varken", "Colli gemengd",
      "Colli rund",  "Fondue varié", "Fondue de luxe", "Gourmet/steengrill", "Hoofdvlees", "Grillworst", "Hoevebroodje", "Bloedworst", "Witte pens", "Pur Porc De Spycker 'Stantje'"]

  // const [bestelling, setBestelling] = useState({
  //   producten: producten.map((product) => ({ 
  //     ...product, gewicht: 0, aantalStuks: 0, isPerPiece: perPieceProducten.includes(product.naam) ? false : null,
  //    })),
  //   naam: '',
  //   email: '',
  //   telefoon: '',
  //   bericht: ''
  // });

  const [showInfoId, setShowInfoId] = useState(null);
  const colliProductNamen = ["Colli varken", "Colli rund", "Colli gemengd", "Fondue varié", "Fondue de luxe", "Gourmet/steengrill", "Gehaktbroodje", "Kalkoenfiletgebraad", "Konijn"];

  const [bestelling, setBestelling] = useState(() => ({
  producten: producten.map(product => {
    const isOnlyPerPiece = alleenStuk.includes(product.naam);
    const isPerPiece = isOnlyPerPiece || perPieceProducten.includes(product.naam);

    return {
      ...product,
      isPerPiece,
      toggleDisabled: isOnlyPerPiece, // disables toggle als alleen per stuk
      gewicht: 0,
      aantalStuks: 0,
    };
  }),
  naam: '',
  email: '',
  telefoon: '',
  bericht: ''
}));

  const togglePerPiece = (productId) => {
    setBestelling((prevBestelling) => {
      const updatedProducts = prevBestelling.producten.map((product) =>
        product.id === productId
          ? {
              ...product,
              isPerPiece: !product.isPerPiece, // Toggle waarde
              gewicht: !product.isPerPiece ? 0 : product.gewicht, // Reset gewicht als het naar stuks gaat
              aantalStuks: product.isPerPiece ? 0 : product.aantalStuks, // Reset stuks als het naar gewicht gaat
            }
          : product
      );
      return { ...prevBestelling, producten: updatedProducts };
    });
  };


  const [modalOpen, setModalOpen] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');
  // const [isPerPiece, setIsPerPiece] = useState(false);

  const handleWeightChange = (productId, increment) => {
    setBestelling((prevBestelling) => {
      const updatedProducten = prevBestelling.producten.map((product) => {
        if (product.id === productId) {
          const nieuwGewicht = (parseFloat(product.gewicht.toString().replace(',', '.')) || 0) + increment;
          const adjustedWeight = nieuwGewicht < 0 ? 0 : nieuwGewicht;
          return { ...product, gewicht: adjustedWeight.toString().replace('.', ',') };
        }
        return product;
      });

      return { ...prevBestelling, producten: updatedProducten };
    });
  };

  const handlePieceChange = (productId, change) => {
    setBestelling((prevBestelling) => {
      const updatedProducts = prevBestelling.producten.map((product) =>
        product.id === productId && product.isPerPiece
          ? { ...product, aantalStuks: Math.max(0, (product.aantalStuks || 0) + change) }
          : product
      );
      return { ...prevBestelling, producten: updatedProducts };
    });
  };

  // Verwerkt de input van de gewicht-invoer
  const handleWeightInputChange = (productId, value) => {
    if (value === "") {
      setBestelling((prevBestelling) => ({
        ...prevBestelling,
        producten: prevBestelling.producten.map((product) =>
          product.id === productId ? { ...product, gewicht: "" } : product
        ),
      }));
      setWarningMessage('');
      return;
    }

    const validInput = /^[0-9]*[,]?[0-9]*$/.test(value) && !value.includes("-");

    if (validInput) {
      const nummeriekGewicht = parseFloat(value.replace(",", "."));
      if (nummeriekGewicht > 50) {
        setWarningMessage('Gewicht boven 50 kg kan niet besteld worden, contacteer ons hiervoor.');
        return;
      } else {
        setWarningMessage('');
      }
      setBestelling((prevBestelling) => ({
        ...prevBestelling,
        producten: prevBestelling.producten.map((product) => {
          if (product.id === productId) {
            return {
              ...product,
              gewicht: value,
              ...(product.isPerPiece && { aantalStuks: value })
            };
          }
          return product;
        }),
      }));
    }
  };

  // Verwerkt de input van het aantal stuks
  const handlePieceInputChange = (productId, value) => {
    const validInput = /^[0-9]*$/.test(value) && !value.includes("-");

    if (validInput) {
      setBestelling((prevBestelling) => ({
        ...prevBestelling,
        producten: prevBestelling.producten.map((product) =>
          product.id === productId ? { ...product, aantalStuks: Math.max(0, parseInt(value)) } : product
        ),
      }));
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setModalOpen(true);
  };

  const handleResetBestelling = () => {
    setBestelling({
      producten: producten.map((product) => ({ ...product, gewicht: 0, aantalStuks: 0 })),
      naam: '',
      email: '',
      telefoon: '',
      bericht: ''
    });
    setModalOpen(false);
  };

  const [selectedCategory, setSelectedCategory] = useState('Rund');

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  }

  return (
    <>
    <Helmet>
        <title>Winkel | Hoeveslagerij De Spycker</title>
        <meta name="description" content="Stel hier uw bestelling samen of kijk rond in ons assortiment, kies nadien voor het afhaalpunt dat het best voor u past!"/>
        <link rel="canonical" href="https://www.hoeveslagerijdespycker.be/bestellen" />
    </Helmet>
    <div className="flex justify-center items-center mt-20 bg-gray-100">
      <div className="flex flex-wrap w-full max-w-6xl">
        {/* Producten lijst (linkerkant) */}
        <div className="w-full md:w-2/3 p-4 border-b md:border-r md:border-b-0">
          <h2 className="text-2xl font-bold">Beschikbare Producten</h2>
          <p className="text-sm">Gelieve uw bestellingen ten laatste op woensdag te plaatsen voor diezelfde week.</p>
          <p className="text-sm text-red-600">Producten kunnen zowel per <strong className="underline">GEWICHT</strong> of per <strong className="underline">STUK</strong> besteld worden.</p>
          <p className="text-sm text-red-600"><strong>BETALING</strong>: In de winkel is er <strong>GEEN bancontact</strong>, wel <strong>Payconiq</strong> of betalen met de <strong>bank-app</strong>.</p>
          {/* {selectedCategory !== "Panklaar" && selectedCategory !== "Charcuterie" && (<h3 className="text-center text-red-900 md:text-left mb-4">Bij 3 kg bestellen, 10% korting</h3>)} */}
          <div className="mb-4 text-center mt-4">
            {/* <button
              onClick={() => window.scrollTo({ top: document.body.scrollHeight - 850, behavior: 'smooth' })}
              className="px-4 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600"
            >
              Bestelling afronden
            </button> */}
          </div>
          {warningMessage && (
            <div className="mt-2 text-red-500 text-sm"><strong>{warningMessage}</strong></div>
          )}
          <div className="mb-4">
            <label htmlFor="categorie" className="mr-2">Selecteer een categorie:</label>
            <select
              id="categorie"
              value={selectedCategory}
              onChange={handleCategoryChange}
              className="p-2 border border-gray-300 rounded-md"
            >
              {Object.keys(categorieen).map((categorie) => (
                <option key={categorie} value={categorie}>
                  {categorie}
                </option>
              ))}
            </select>
          </div>

           {/* Producten lijst per categorie */}
           <div className="mt-4">
            <h2 className="text-2xl font-bold">{selectedCategory}</h2>
            <ul>
              {categorieen[selectedCategory].map((productNaam, index) => {
  const product = producten.find(p => p.naam === productNaam);
  if (!product) return null;

  const productData = bestelling.producten.find(p => p.id === product.id);
  const isPerPiece = productData?.isPerPiece;
  const isToggleDisabled = alleenStuk.includes(product.naam);
  const magToggelen = perPieceProducten.includes(product.naam) && !isToggleDisabled;



  const colliInhoud = {
  "Colli gemengd": [
    "1kg braadworst",
    "1kg hamburger",
    "1kg kaasburger",
    "1kg gehakt",
    "1kg hespegebraad",
    "1kg filetkotelet",
    "1kg stoofvlees",
    "1kg biefstuk",
    "1kg tournedos",
    "1kg rosbief",
  ],
  "Colli rund": [
    "2kg stoofvlees",
    "2kg rosbief",
    "2kg hamburger",
    "1kg biefstuk",
    "1kg tournedos",
    "1kg americain",
    "1kg blinde vinken",
  ],
  "Colli varken": [
    "2kg worst",
    "2kg gehakt",
    "1kg varkenstoofvlees",
    "1kg hespegebraad",
    "1kg schnitzel",
    "1kg filetkotelet",
    "1kg vers spek",
    "1kg vleesribben"
  ],
  "Fondue varié": ["Gelieve dit minstens 2 dagen op voorhand te bestellen."],

  "Fondue de luxe": ["Gelieve dit minstens 2 dagen op voorhand te bestellen."],

  "Gourmet/steengrill": ["Gelieve dit minstens 2 dagen op voorhand te bestellen."],

  "Gehaktbroodje": ["Gelieve enkel 0,5 kg of 1 kg te bestellen."],

  "Kalkoenfiletgebraad": ["Gelieve dit ten laatste woensdag te bestellen."],

  "Konijn": ["Gelieve dit ten laatste woensdag te bestellen."]
};

  return (
    <li key={product.id} className="mr-10 mb-4 flex justify-between gap-2">
      <div className="flex flex-wrap items-center justify-between w-full">
        <span className="text-sm sm:text-base w-full sm:w-auto sm:flex-1 truncate" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {product.naam}
          {colliProductNamen.includes(product.naam.trim()) && (
            <button
              type="button"
              onClick={() => setShowInfoId(product.id)}
              className="ml-2 text-blue-700 hover:text-blue-900 text-xs"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-11.25a.75.75 0 10-1.5 0v.25a.75.75 0 001.5 0v-.25zM9 9.25a.75.75 0 011.5 0v4a.75.75 0 01-1.5 0v-4z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
        </span>

        {/* Toggle knop alleen tonen als toggelen mag */}
        {magToggelen && (
          <div className="ml-auto flex items-center gap-2">
            <button
              type="button"
              onClick={() => togglePerPiece(product.id)}
              className="px-2 sm:px-3 py-1 mr-2 text-xs sm:text-sm text-white bg-red-900 rounded-md hover:bg-red-500"
            >
              {isPerPiece ? "Per kg" : "Per stuk"}
            </button>
          </div>
        )}

        {/* Toon invoer per stuk of per gewicht */}
        {isPerPiece ? (
          <div className="ml-auto flex items-center gap-2">
            <button
              type="button"
              onClick={() => handlePieceChange(product.id, -1)}
              className="px-3 py-1 text-white bg-red-900 rounded-md hover:bg-red-500"
              disabled={productData.aantalStuks <= 0}
            >
              -
            </button>
            <input
              type="number"
              value={productData.aantalStuks || ""}
              onChange={(e) => handlePieceInputChange(product.id, e.target.value)}
              className="w-16 sm:w-20 p-1 text-xs sm:text-sm border border-gray-300 rounded-md placeholder-gray-400 text-center"
              placeholder="stuks"
              min="0"
            />
            <button
              type="button"
              onClick={() => handlePieceChange(product.id, 1)}
              className="px-2 sm:px-3 py-1 text-xs sm:text-sm text-white bg-green-900 rounded-md hover:bg-green-500"
            >
              +
            </button>
          </div>
        ) : (
          <div className="ml-auto flex items-center gap-2">
            <button
              type="button"
              onClick={() => handleWeightChange(product.id, -0.25)}
              className="px-3 py-1 text-white bg-red-900 rounded-md hover:bg-red-500"
              disabled={productData.gewicht <= 0}
            >
              -
            </button>
            <input
              type="text"
              value={productData.gewicht || ""}
              onChange={(e) => handleWeightInputChange(product.id, e.target.value)}
              className="w-16 sm:w-20 p-1 text-xs sm:text-sm border border-gray-300 rounded-md placeholder-gray-400 text-center"
              placeholder="kg"
              min="0"
              step="0.25"
              inputMode="decimal"
            />
            <button
              type="button"
              onClick={() => handleWeightChange(product.id, 0.25)}
              className="px-3 text-white py-1 bg-green-900 rounded-md hover:bg-green-500"
            >
              +
            </button>
          </div>
        )}
      </div>
      {showInfoId === product.id && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white p-5 rounded-md shadow-lg max-w-sm">
          <h2 className="text-lg font-bold mb-2">{product.naam}</h2>
          <ul className="list-disc list-inside text-sm text-gray-700 mb-4">
            {(colliInhoud[product.naam] || ["Geen inhoud beschikbaar."]).map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          <button
            onClick={() => setShowInfoId(null)}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
          >
            Sluiten
          </button>
        </div>
      </div>)}
    </li>
  );
})}
            </ul>
          </div>
        </div>


        {/* Bestelformulier (rechterkant) */}
        <div className="w-full md:w-1/3 p-4 mt-4 md:mt-0">
          <h2 className="text-2xl font-bold mb-4">Bestelling Plaatsen</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="naam" className="block text-sm font-medium text-gray-700">Naam</label>
              <input
                type="text"
                id="naam"
                value={bestelling.naam}
                onChange={(e) => setBestelling({ ...bestelling, naam: e.target.value })}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                required
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">E-mail</label>
              <input
                type="email"
                id="email"
                value={bestelling.email}
                onChange={(e) => setBestelling({ ...bestelling, email: e.target.value })}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                required
              />
            </div>

            <div>
              <label htmlFor="telefoon" className="block text-sm font-medium text-gray-700">Telefoonnummer</label>
              <input
                type="tel"
                id="telefoon"
                value={bestelling.telefoon}
                onChange={(e) => setBestelling({ ...bestelling, telefoon: e.target.value })}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                pattern="^[0-9]{10}$"
                required
              />
              <p className="text-sm text-gray-500">Vul een geldig telefoonnummer in (bijv. 0479123456).</p>
            </div>

            <div>
              <label htmlFor="bericht" className="block text-sm font-medium text-gray-700">Bericht (optioneel)</label>
              <input
                type="text"
                id="bericht"
                value={bestelling.bericht}
                onChange={(e) => setBestelling({ ...bestelling, bericht: e.target.value })}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-red-900 text-white py-2 px-4 rounded-md hover:bg-red-500"
            >
              Bestelling Plaatsen
            </button>
          </form>
        </div>
      </div>

      {modalOpen && (
        <BestellingBevestigen
          producten={bestelling.producten}
          naam={bestelling.naam}
          email={bestelling.email}
          telefoon={bestelling.telefoon}
          bericht={bestelling.bericht}
          onConfirm={handleResetBestelling}
          onCancel={() => setModalOpen(false)}
        />
      )}
    </div>
    </>
  );
};

export default ProductenBestelling;
